import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminal-navigation',
  templateUrl: './terminal-navigation.component.html',
  styleUrls: ['./terminal-navigation.component.css']
})
export class TerminalNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
